module.exports = __webpack_public_path__ + "static/media/B1_DIFF.8f3c2eee.png";